import { __rest } from 'tslib';
import React from 'react';
import { Image } from '@teko/ui';

const Logo = (_a) => {
    var { variant = 'full', logoFull, logoLite, alt } = _a, props = __rest(_a, ["variant", "logoFull", "logoLite", "alt"]);
    return (React.createElement(Image, Object.assign({ src: variant === 'full' ? logoFull : logoLite, alt: alt }, props)));
};

export { Logo };
